import { useMemo } from 'react'

import { useSalesReportFilters } from '../useSalesReportFilters'
import { useFetchSalesByItemReport } from './useFetchSalesByItemReport'

export const useSalesByItemReport = () => {
  const [{ period }] = useSalesReportFilters()
  const { salesByItemReport, isLoading } = useFetchSalesByItemReport({ period })

  // productId is missing from the backend, so here temporary ID needed for the sales report graph is created
  const salesByItemReportWithId = useMemo(
    () =>
      salesByItemReport.map((salesReportItem, index) => {
        return { ...salesReportItem, productId: `${salesReportItem?.productName}-${index}` }
      }),
    [salesByItemReport],
  )

  return { salesByItemReport: salesByItemReportWithId, isLoading }
}
